import React, { useContext } from 'react';
import TrainerLayout from './TrainerLayout';
import Tabs from '../commons/Tabs'; // Adjust the path as needed
import { TrainerContext } from '../../context/TrainerContext';
import SchoolData from "./SchoolData";
import TrainersList from "./TrainersList";
import SchoolSettings from "./SchoolSettings";
import OfferedServices from "./OfferedServices";

const SchoolDetails = () => {
    const { trainer } = useContext(TrainerContext);
    const schoolId = trainer?.schoolId;

    if (!schoolId) {
        return <div>Loading...</div>;
    }

    const tabs = [
        {
            key: 'dane-szkoly',
            label: 'Dane szkoły',
            endpoint: `/api/v1/school/${schoolId}`, // Used by Tabs for caching/pagination if needed
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <SchoolData schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'trenerzy',
            label: 'Trenerzy',
            endpoint: `/api/v1/trainer/find-all/${schoolId}`, // This is where we fetch trainers for the table
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <TrainersList schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'ustawienia',
            label: 'Ustawienia',
            endpoint: `/api/v1/school/${schoolId}/settings`,
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <SchoolSettings schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'uslugi',
            label: 'Usługi',
            endpoint: `/api/v1/services/school/${schoolId}`, // Optional: used for caching/pagination if needed
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <OfferedServices schoolId={schoolId} />
                </div>
            ),
        },
    ];

    return (
        <TrainerLayout>
            <div style={{
                padding: '20px',
                boxSizing: 'border-box',
                backgroundColor: '#f9fafb',
                minHeight: '100vh'
            }}>


                <div style={{
                    overflow: 'hidden'
                }}>
                    <Tabs tabs={tabs} activeId={schoolId} />
                </div>
            </div>
        </TrainerLayout>
    );
};

export default SchoolDetails;